export function useHotelByPropertyCode(propertyCode: string) {
  const { hotels } = useHotels();

  const hotel = computed(() =>
    hotels.value.find((hotel) => hotel.propertyCode === propertyCode),
  );

  return hotel;
}

export default function useCurrentHotel() {
  const { name, params } = useRoute();
  const { hotels } = useHotels();

  const currentHotel = computed(() =>
    hotels.value.find((hotel) => {
      const [continent, city, hotelSlug] = hotel.slug.split("/");
      const {
        continent: continentParam,
        city: cityParam,
        hotelSlug: hotelSlugParam,
      } = params;

      // Rooftop bars never have hotel in the slug itself, so remove it to do an exact match
      if (name?.toString().includes("rooftop-bars")) {
        return (
          continent === continentParam &&
          city === cityParam &&
          hotelSlug.replace(/-hotel$/, "") === hotelSlugParam
        );
      }

      return (
        continent === continentParam &&
        city === cityParam &&
        hotelSlug === hotelSlugParam
      );
    }),
  );

  return currentHotel;
}
